(function () {
  const LOJA_02_URL = 'https://reveli.online';
  let skuIndex = null;       // Mapa SKU -> variant_id (carregado 1x e cacheado)
  let skuIndexPromise = null;

  // ─── XHR nativo (evita o window.fetch sobrescrito pelo Kachhin) ───
  function xhrGet(url) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch (e) { reject(new Error('JSON parse error')); }
        } else {
          reject(new Error(`HTTP ${xhr.status}`));
        }
      };
      xhr.onerror = () => reject(new Error('XHR network error'));
      xhr.send();
    });
  }

  // ─── Shopify Markets ───────────────────────────────────────────────
  function getMarketContext() {
    const s = window.Shopify || {};
    return {
      currency:    s.currency?.active || s.currencyCode || null,
      countryCode: s.country || s.market?.countryCode || null
    };
  }

  // ─── Constrói índice SKU → variant_id da Loja 02 (não depende de handle) ──
  // Pagina via /products.json?limit=250&page=N até esgotar
  async function buildSkuIndex() {
    if (skuIndex) return skuIndex;
    if (skuIndexPromise) return skuIndexPromise;

    skuIndexPromise = (async () => {
      const index = {};
      let page = 1;
      while (true) {
        let data;
        try {
          data = await xhrGet(`${LOJA_02_URL}/products.json?limit=250&page=${page}`);
        } catch (e) {
          console.warn('[redirect] ⚠️ Falha ao paginar produtos da Loja 02:', e.message);
          break;
        }
        const products = data.products || [];
        if (!products.length) break;

        products.forEach(p => {
          p.variants.forEach(v => {
            if (v.sku) index[v.sku.trim().toUpperCase()] = v.id;
          });
        });

        if (products.length < 250) break; // última página
        page++;
        if (page > 20) break; // segurança contra loop infinito
      }
      skuIndex = index;
      console.log(`[redirect] ✅ Índice de SKUs da Loja 02 construído: ${Object.keys(index).length} SKUs`);
      return index;
    })();

    return skuIndexPromise;
  }

  // ─── Resolve Variant IDs usando o índice de SKU ───────────────────
  async function resolveVariantIds(cartItems) {
    const index = await buildSkuIndex();
    const result = {};
    cartItems.forEach(item => {
      const sku = (item.sku || '').trim().toUpperCase();
      if (sku && index[sku]) {
        result[item.key || item.variant_id] = index[sku];
      }
    });
    return result;
  }

  // ─── Monta URL de redirect ─────────────────────────────────────────
  function buildRedirectURL(cartItems, resolved) {
    if (!cartItems?.length) return null;
    const items = cartItems.map(item => {
      const id = resolved[item.key || item.variant_id];
      if (!id) { console.error(`[redirect] ❌ SKU não encontrado na Loja 02: ${item.sku || '(sem SKU)'} — ${item.title}`); return null; }
      return `${id}:${item.quantity}`;
    }).filter(Boolean);
    if (!items.length) return null;

    const { currency, countryCode } = getMarketContext();
    const params = new URLSearchParams();
    if (currency)    params.set('currency', currency);
    if (countryCode) params.set('country',  countryCode);
    const qs = params.toString();
    return `${LOJA_02_URL}/cart/${items.join(',')}${qs ? '?' + qs : ''}`;
  }

  // ─── Handler principal ─────────────────────────────────────────────
  async function redirectToLoja02(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    const btn = event.currentTarget;
    const orig = btn.innerHTML;
    btn.innerHTML = '<span>Please wait...</span>';
    btn.disabled = true;

    try {
      const cart = await xhrGet('/cart.js');
      if (!cart.items?.length) { window.location.href = '/cart'; return; }

      const resolved = await resolveVariantIds(cart.items);
      const url = buildRedirectURL(cart.items, resolved);

      if (url) {
        console.log('[redirect] ✅ Redirecionando:', url);
        window.location.href = url;
      } else {
        throw new Error('Nenhum SKU do carrinho foi encontrado na Loja 02');
      }
    } catch (e) {
      console.error('[redirect] ❌', e.message);
      // Vai pro carrinho vazio da Loja 02 (não pro checkout vazio, que cai na home)
      window.location.href = LOJA_02_URL + '/cart';
    }
  }

  // ─── Attach: botões nativos Minimog ───────────────────────────────
  function attachNativeRedirect() {
    document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], [data-checkout-button]'
    ).forEach(btn => {
      if (btn.dataset.redirectAttached) return;
      btn.dataset.redirectAttached = 'true';
      btn.addEventListener('click', redirectToLoja02);
    });
  }

  // ─── Attach: Kachhin Cart com capture:true ────────────────────────
  function attachKachhinRedirect() {
    document.querySelectorAll(
      '#kaching-cart__checkout-button, .kaching-cart__checkout-button'
    ).forEach(btn => {
      if (btn.dataset.redirectAttached) return;
      btn.dataset.redirectAttached = 'true';
      btn.addEventListener('click', redirectToLoja02, true); // capture:true = roda antes do Kachhin
      console.log('[redirect] ✅ Kachhin Cart interceptado (capture)');
    });
  }

  // ─── Master attach ─────────────────────────────────────────────────
  function attachAll() {
    attachNativeRedirect();
    attachKachhinRedirect();
  }

  // ─── MutationObserver ──────────────────────────────────────────────
  new MutationObserver(() => attachAll())
    .observe(document.body, { childList: true, subtree: true });

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', attachAll)
    : attachAll();

  document.addEventListener('minimog:cart-updated', () => setTimeout(attachAll, 100));
  document.addEventListener('kaching:cart:updated', () => setTimeout(attachKachhinRedirect, 150));
  document.addEventListener('kaching:cart:opened',  () => setTimeout(attachKachhinRedirect, 150));

  // Pré-carrega o índice de SKUs assim que a página carrega (não espera o clique)
  buildSkuIndex();

})();